// Bug MEP — Univers Métier (WP-delegated) pages.
//
// The lateral menu (#sidebar-turbo-container) and the bottom tab bar (#mobile-menu)
// are `data-turbo-permanent`, so Turbo preserves them across visits and the
// server-rendered `active` of the NEW page is never applied — the active item
// stays stale until a full reload. On normal NT pages the inline init at the
// bottom of _lateral_and_mobile re-runs `selectLateralMenu` / `selectBottomMenu`
// on every render, but that block is DISCARDED by the WP wrapper
// `wordpress/layouts/_lateral_menu` (`- render` + only `content_for(:lateral_menu)`).
//
// So we re-sync the active item on `turbo:load` from the fresh, NON-permanent
// `#bottom-menu-page-param[data-page]` (replaced on every Turbo render). Scoped to
// `child_metier` — the only universe served this way — so normal pages, where the
// inline init already runs, are untouched.
function syncUniversMetierActiveMenu() {
  const param = document.getElementById('bottom-menu-page-param');
  if (!param) return;

  const lateral = document.getElementById('lateral-menu');
  const universe = lateral && lateral.dataset.startedUniverse;
  if (universe !== 'child_metier') return;

  const view = param.dataset.page;
  if (!view) return;

  if (window.selectBottomMenu) window.selectBottomMenu(view);
  if (window.selectLateralMenu) window.selectLateralMenu(universe, view);
}

document.addEventListener('turbo:load', syncUniversMetierActiveMenu);

export { syncUniversMetierActiveMenu };
